<template>
  <div>
    <div class="block">
      <!-- ElementUI轮播图 -->
      <el-carousel height="150px" v-if="imgList.length > 0">
        <el-carousel-item v-for="(item,index) in imgList" :key="index">
          <!-- <div class="ImgTextbox">
            <div class="ImgText">
              <div :class="item.StyleName">
                {{ item.title }}
              </div>
              <div :class="item.StyleNames">
                {{ item.titles }}
              </div>
              <div :class="item.buttomStyle" >
                {{ item.buttonName }}
              </div>
            </div>
          </div> -->
          <img :src="item.path" alt="" @click="buttonlinkUrl(item.linkUrl)">
        </el-carousel-item>
      </el-carousel>
      <div class="NoData" v-else>
        <img src="@/assets/DefaultPage/SwiperNoData.png" alt="轮播图未上传" class="NoDataImg">
      </div>
    </div>
  </div>
</template>

<script>
import {
  BannerShow
} from '@/api/channel'
export default {
  data() {
    return {
      // imgList: [
      //   { path: require("@/assets/channel/swpscs.png"), title: "归创通桥", 
      //   buttonName: "立即查看", buttomStyle: "buttonCss", StyleName: "title", 
      //   titles: "我们是综合解决方案提供者，提供外周和神经血管植介入医疗器械最全面的产品方案。", StyleNames: "titles" },
      // ],
      imgList: [],

    }
  },
  mounted() {
    this.BannerShow()
  },
  methods: {

    async BannerShow() {
      let {
        code,
        message,
        data
      } = await BannerShow({})
      if (code == 0) {
        this.imgList = data
      } else {
        this.$message.warning(message)
      }

    },
    // 外链
    buttonlinkUrl(URL) {
      if (URL) {
        window.open(URL, '_blank')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.block {
  user-select: none;

  .NoData {
    width: 800px;
    height: 320px;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .NoDataImg {
      width: 320px;
      height: 240px;
     
    }
  }
}
/deep/.el-carousel__container {
  height: 320px !important;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
/deep/.el-carousel__indicators--horizontal {
  .el-carousel__indicator--horizontal button {
    width: 32px;
    height: 4px;
    background: #a1a9b3;
    // border-radius: 50%;
    // opacity: 0.5;
  }

  .el-carousel__indicator--horizontal.is-active button {
    width: 32px;
    height: 4px;
    background: #1e3799;
    // border-radius: 10px;
  }
}
.ImgText {
  // border: 1px solid rgb(119, 0, 255);
  position: absolute;
  top: -17px;
  width: 488px;
}
.ImgTextbox {
  width: 1200px;
  margin: 0 auto;
  // border: 1px solid red;
}
.title {
  width: 488px;
  height: 50px;
  // border: 1px solid red;
  position: relative;
  z-index: 9999;
  margin-top: 103px;
  color: #16181a;
  font-size: 36px;
}
.titles {
  width: 488px;
  height: 50px;
  // border: 1px solid red;
  position: relative;
  z-index: 9999;
  margin-top: 20px;
  font-weight: 400;
  color: #424e66;
  font-size: 16px;
}
.buttonCss {
  width: 140px;
  height: 48px;
  position: relative;
  background-color: #00266d;
  color: #fff;
  border-radius: 2px;
  font-size: 16px;
  z-index: 9999;
  margin-top: 80px;
  text-align: center;
  line-height: 48px;
  cursor: pointer;
}
</style>